import React from 'react';
import { useTranslation } from 'react-i18next';
import PatientControlButton from 'components/atoms/patentControlButton';
import ControlRequestIcon from 'components/atoms/icons/controlRequestIcon';
import {
  useAppointmentRequest,
  useRequestButtons,
} from 'infrastructure/hooks/control-panel';
import { ModuleType } from 'infrastructure/enums';
import ControlButtonDropdown from 'components/atoms/controlPanelDropdownButton/controlButtonDropdown';
import { useAccess } from 'infrastructure/hooks/access/useAccess';

interface IProps {
  module: ModuleType;
  patientGuid: string;
}

const RequestsControl: React.FC<IProps> = (props) => {
  const { module, patientGuid } = props;

  const { t } = useTranslation();

  const { sendAppointmentRequest, sendAppointmentRequestLoading } =
    useAppointmentRequest();

  const {
    patientInfo,
    isBlockRpmModule,
    isCcmActionDisabled,
    isCombinedModule,
    isCcmModule,
    isReadOnlyRole,
  } = useAccess({
    module,
    patientGuid,
  });

  const requestButtons = useRequestButtons({
    appointmentsFlagActive: patientInfo?.appointmentsFlagActive ?? false,
    sendAppointmentRequest() {
      sendAppointmentRequest({
        patientGuid,
        rogerModule: isCcmModule ? ModuleType.CCM : undefined,
      });
    },
  });

  const disabled = isCombinedModule
    ? isReadOnlyRole || isBlockRpmModule
    : isCcmActionDisabled;

  return (
    <>
      <ControlButtonDropdown
        toggleBtn={
          <PatientControlButton
            Icon={ControlRequestIcon}
            label={t('labels.requests')}
            loading={sendAppointmentRequestLoading}
            disabled={disabled}
          />
        }
        options={requestButtons}
        isRpm
      />
    </>
  );
};

export default RequestsControl;
